var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeadzone = function SvgDeadzone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.849 9.151 24 3 9.151 9.151 3 24l6.151 14.85L24 45l14.849-6.15L45 24zm-14.85 12.414 9.61-5.547v15.964l-9.61-5.547-9.608 5.547V16.018z"
  })));
};
export default SvgDeadzone;